import api from './axios';

export const sendOtp = async (phone) => {
  const response = await api.post('/auth/send-otp', { phone });
  return response.data;
};

export const checkPhone = async (phone) => {
  const response = await api.post('/auth/check-phone', { phone });
  return response.data;
};

export const loginWithPassword = async (phone, password) => {
  const response = await api.post('/auth/login', { phone, password });
  return response.data;
};

export const verifyOtp = async (phone, code, firstName, lastName) => {
  const response = await api.post('/auth/verify-otp', { phone, code, firstName, lastName });
  return response.data;
};

export const setPassword = async (password) => {
  const response = await api.post('/auth/set-password', { password });
  return response.data;
};

export const setAuthData = (token, user) => {
  localStorage.setItem('authToken', token);
  localStorage.setItem('authUser', JSON.stringify(user));
};

export const getAuthData = () => {
  const token = localStorage.getItem('authToken');
  const user = localStorage.getItem('authUser');
  return { token, user: user ? JSON.parse(user) : null };
};

export const clearAuthData = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authUser');
  // Defensive: the OTP flow only persists the two keys above in
  // localStorage, but a reliable logout must leave no auth remnant
  // behind in any web storage (legacy keys, session copies). Any
  // failure here is non-fatal — AuthContext in-memory state is still
  // cleared by the caller, and ProtectedRoute reads localStorage.
  try {
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('authUser');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    localStorage.removeItem('token');
  } catch {
    // Storage unavailable (e.g. private mode) — ignore.
  }
};

export const isAuthenticated = () => {
  const { token } = getAuthData();
  return !!token;
};
